import { TFunction } from 'i18next'
import { ReactElement } from 'react'

import { EInvoicingCompanyInfoStep } from '../../../elements/EInvoicingCompanyInfoStep'
import { EInvoicingEmptyStateStep } from '../../../elements/EInvoicingEmptyStateStep'
import { EInvoicingFilesSuccessStep } from '../../../elements/EInvoicingFilesSuccessStep'
import { EInvoicingGenericUpload } from '../../../elements/EInvoicingGenericUpload'
import { EInvoicingGenericUploadInfoSteps } from '../../../elements/EInvoicingGenericUploadInfoSteps'
import { EInvoicingNavigationWrapper } from '../../../elements/EInvoicingNavigationWrapper'
import { EInvoicingSelectIDTypeStep } from '../../../elements/EInvoicingSelectIDTypeStep'
import { EInvoicingSignature } from '../../../elements/EInvoicingSignature'
import { EInvoicingSetupPath } from '../../../types'

export const getStepComponentMapFromPath = (
  t: TFunction<'translation', undefined>,
): Record<EInvoicingSetupPath, ReactElement> => ({
  'empty-state': <EInvoicingEmptyStateStep />,
  'company-information': <EInvoicingCompanyInfoStep />,
  'upload-documents': (
    <EInvoicingNavigationWrapper step="UPLOAD_DOCS">
      <EInvoicingSelectIDTypeStep />
    </EInvoicingNavigationWrapper>
  ),
  'upload-id-front': (
    <EInvoicingNavigationWrapper step="UPLOAD_ID_FRONT">
      <EInvoicingGenericUpload
        key="upload-id-front"
        documentType="ID_FRONT"
        progressHeading={t('e_invoice.kyc.step.select_id.progress.title')}
        title={t('e_invoice.kyc.step.upload_id.title.front')}
        subtitle={<EInvoicingGenericUploadInfoSteps />}
        uploadTitle={t('e_invoice.kyc.step.upload_id.upload.title')}
      />
    </EInvoicingNavigationWrapper>
  ),
  'upload-id-back': (
    <EInvoicingNavigationWrapper step="UPLOAD_ID_BACK">
      <EInvoicingGenericUpload
        key="upload-id-back"
        documentType="ID_BACK"
        progressHeading={t('e_invoice.kyc.step.select_id.progress.title')}
        title={t('e_invoice.kyc.step.upload_id.title.back')}
        subtitle={<EInvoicingGenericUploadInfoSteps />}
        uploadTitle={t('e_invoice.kyc.step.upload_id.upload.title')}
      />
    </EInvoicingNavigationWrapper>
  ),
  'upload-passport': (
    <EInvoicingNavigationWrapper step="UPLOAD_PASSPORT">
      <EInvoicingGenericUpload
        key="upload-passport"
        documentType="PASSPORT"
        progressHeading={t('e_invoice.kyc.step.select_id.progress.title')}
        title={t('e_invoice.kyc.step.upload_passport.title')}
        subtitle={<EInvoicingGenericUploadInfoSteps />}
        uploadTitle={t('e_invoice.kyc.step.upload_id.upload.title')}
      />
    </EInvoicingNavigationWrapper>
  ),
  'upload-success': (
    <EInvoicingNavigationWrapper step="FILES_SUCCESS">
      <EInvoicingFilesSuccessStep />
    </EInvoicingNavigationWrapper>
  ),
  signature: (
    <EInvoicingNavigationWrapper step="SIGNATURE">
      <EInvoicingSignature />
    </EInvoicingNavigationWrapper>
  ),
})
